// extracted by mini-css-extract-plugin
export default {"root":"StuTableColumn_root__2p1ee","name":"StuTableColumn_name__l3KY1","stuNo":"StuTableColumn_stuNo__U8cIb"};